<template>
    <div class="MentoringQuestions container my-20 flex flex-col justify-start">
        <h2 class="mb-4 text-left text-2xl font-black text-black dark:text-txt-headings lg:text-4xl lg:leading-[46.8px]">
            Často kladené otázky
        </h2>

        <div class="flex max-w-3xl flex-col">
            <div v-for="(question, idx) in questions" :key="idx">
                <CCollapse class="border-b border-solid border-gray-200 dark:border-default">
                    <template #title>{{ question.title }}</template>
                    <template #body>
                        <slot v-if="$slots.body" name="body" :value="question.body" />
                        <p v-else v-html="question.body" />
                    </template>
                </CCollapse>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import CCollapse from '@/components/ui/CCollapse.vue'

export interface FrequentQuestion {
    title: string
    body: string
}

defineProps<{
    questions: FrequentQuestion[]
}>()
</script>
